import PropTypes from "prop-types";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { visuallyHidden } from "@mui/utils";
import { Link, useParams } from "react-router-dom";
import React, { useEffect, useState, useRef } from "react";
import NavBar from "../Navbar/Navbar";
import getCookie, { setDistrictCookie, userState } from "../../Atom";
import "./style.css";
import CloseIcon from "@material-ui/icons/Close";
import {
  getAllExperimentsForDistrictAdmin,
  editAnExperiment,
  getStudentByclassId,
  getClassesByTeachers,
  getAllSchoolTeachers,
  getSchoolByDistrictAdmin,
} from "./api";
import "./style.css";
import ReactPaginate from "react-paginate";
import { useHistory } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
// import * as React from 'react';
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import { Dialog, DialogTitle, Grid, TextField } from "@material-ui/core";
import AutoCompletes from "./AutoCompletes";
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const headCells = [
  {
    id: "serialId",
    numeric: false,
    disablePadding: true,
    label: "Serial Id",
    width: "280px",
    maxWidth:"350"
  },
  {
    id: "_id",
    numeric: false,
    disablePadding: true,
    label: "Exp Id",
      width: "150px",
    maxWidth:"170px"
  },
  {
    id: "deviceName",
    numeric: false,
    disablePadding: true,
    label: "Device Name",
  },
  {
    id: "fuelVolume",
    numeric: true,
    disablePadding: true,
    label: "Fuel Volume",
  },
  {
    id: "nozzleDia",
    numeric: true,
    disablePadding: true,
    label: "Nozzle Diameter",
  },
  {
    id: "pressure",
    numeric: true,
    disablePadding: true,
    label: "Pressure",
  },
  {
    id: "className",
    numeric: false,
    disablePadding: true,
    label: "Class",
  },
  {
    id: "studentName",
    numeric: false,
    disablePadding: true,
    label: "Student",
  },
  {
    id: "date",
    numeric: true,
    disablePadding: true,
    label: "Date",
  },
  {
    id: "time",
    numeric: true,
    disablePadding: true,
    label: "Time",
  },
  // {
  //   id: 'Analyze',
  //   numeric: true,
  //   disablePadding: true,
  //   label: 'Analyze',
  // },
  // {
  //   id: 'Action',
  //   numeric: true,
  //   disablePadding: true,
  //   label: 'Action',
  // },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead sx={{ zIndex: 99 }}>
      <TableRow>
        {/* <TableCell padding="checkbox">
          
        </TableCell> */}

        {/* <TableCell
					align={'center'}

					padding={'normal'}>
					Serial Id

				</TableCell>


				<TableCell
					align={'center'}
					padding={'normal'}>
					Exp Id
				</TableCell> */}

        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={"center"}
            padding={"normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={
              headCell.width
                ? { width: headCell?.width, maxWidth: headCell?.maxWidth }
                : {}
            }
          >
            <TableSortLabel
              sx={{ display: "flex" }}
              className=" mb-2"
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}

              {orderBy === headCell.id ? (
                <Box component="div" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}

        <TableCell align={"center"} padding={"normal"} sx={{ width: "70px" }}> 
          <div className=" mb-2">Analysis</div>
        </TableCell>
        <TableCell align={"center"} padding={"normal"}>
          <div className=" mb-2">Action</div>
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
  const { numSelected } = props;

  return (
    //
    <div className="pt-10"></div>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function EnhancedTable() {
  const [myUser, setmyUser] = useState();
  const history = useHistory();
  let search = window.location.search;
  let paramse = useParams();
  let params = new URLSearchParams(search);
  const [experiments, setExperiments] = useState([]);
  //	const [page, setPage] = useState(1)
  // const { token } = useRecoilValue(districtAdminState)
  //	const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [totalPage, setTotalPage] = useState(0);
  const [paged, setPaged] = useState(0);
  const [noOfPages, setNoOfPages] = useState(0);
  const [currPage, setCurrPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(25);
  const [serial, setSerial] = useState(null);
  const [currentEdit, setCurrentEdit] = useState();
  const [open, setOpen] = useState();
  const [editmode, setEditmode] = useState();
  const [snackBarShow, setSnackBarShow] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState("");
  const [snackBarSeverity, setSnackBarSeverity] = useState("");
  const [clicked, setclicked] = useState(false);
  const [teacherData, setTeacherData] = useState([]);
  const [schoolData, setSchoolData] = useState([]);

  const logoutHandler = async () => {
    setTimeout(() => {
      // setmyUser({
      // 	fName: null,
      // 	userId: null,
      // 	token: null,
      // 	lName: null,
      // })
      setDistrictCookie({
        fName: null,
        lName: null,
        token: null,
        userId: null,
      });
      let hostname = window.location.host;
      window.location.assign(
        `${window.location.protocol}//${hostname}/school-district`
      );
    });
  };

  const handleClose = () => {
    setOpen(false);
    setEditmode(false);
  };
  const feedBackMsg = (snackShow, snackSeverity, snackMessage) => {
    setSnackBarShow(snackShow);
    setSnackBarSeverity(snackSeverity);
    setSnackBarMessage(snackMessage);
  };
  const handleEditSubmit = async (e) => {
    const _cookie = getCookie("recoil-persist");

    const user = JSON.parse(_cookie)["district_admin_v1"];
    e.preventDefault();
    let { _id, className, studentName, bottleVolume, fuelVolume, nozzleDia } =
      currentEdit;
    let data = {
      className: className,
      studentName: studentName,
      bottleVolume: bottleVolume,
      fuelVolume: fuelVolume,
      nozzleDia: nozzleDia,
      school: currentEdit?.school,
      teacher: currentEdit?.teacher,
    };
    // setclicked(true)
    const res = await editAnExperiment(_id, data, user?.token);
    if (res.error) {
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
    } else {
      feedBackMsg(true, "success", res.res.data.msg);
    }
    // setclicked(false)
    handleClose();
    getListOfExperiments(paged, pageLimit, orderBy, order, user);
  };
  const SnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    feedBackMsg(false, "", "");
  };

  useEffect(() => {
    const _cookie = getCookie("recoil-persist");

    if (!_cookie) {
      logoutHandler();
    } else {
      const user = JSON.parse(_cookie)["district_admin_v1"];
      setmyUser(user);
      let urlPage = parseInt(params.get("page")) || 0;
      let urlLimit = parseInt(params.get("limit")) || pageLimit;
      let urlOrderBy = params.get("orderBy") || "assignedAt";
      let urlOrder = params.get("order") || "desc";
      let urlSerial = params.get("serial");
      if (parseInt(params.get("page")) || parseInt(params.get("limit"))) {
        history.replace({
          pathname: "/experiments",
          search:
            `?${urlSerial ? `serial=${urlSerial}&` : ""}` +
            "page=" +
            urlPage +
            "&limit=" +
            urlLimit +
            "&orderBy=" +
            urlOrderBy +
            "&order=" +
            urlOrder,
        });
        getListOfExperiments(urlPage, urlLimit, urlOrderBy, urlOrder, user);
        setPaged(urlPage);
        setSerial(urlSerial);
        setPageLimit(urlLimit);
        setOrderBy(urlOrderBy);
        setOrder(urlOrder);
      } else {
        history.push({
          pathname: "/experiments",
          search:
            `?${urlSerial ? `serial=${urlSerial}&` : ""}` +
            `page=0&limit=${pageLimit}&orderBy=${orderBy}&order=${order}`,
        });
        getListOfExperiments(0, pageLimit, orderBy, order, user);
      }
    }
  }, []);

  const [expUpdateData, setExpUpdateData] = React.useState({
    teachers: [],
    classes: [],
    students: [],
  });

  const getListOfExperiments = async (pages, limits, orderBy, order, user) => {
    let arr = [];
    let res;
    res = await getAllExperimentsForDistrictAdmin(
      user?.token,
      pages,
      limits,
      orderBy,
      order,
      params.get("serial") ? params.get("serial") : null
    );

    if (res?.error) {
      if (res?.data?.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res?.data?.msg);
      }
    } else {
      let experiment = res?.res?.data?.data?.experiments;
      experiment.forEach((element) => {
        let obj = {
          ...element,
          serialId: element?.deviceSerialId || element?.device?._id,
          deviceName: element?.deviceName || element?.device?.name,
          date: new Date(element.createdAt).toLocaleDateString(),
          time: new Date(element.createdAt).toLocaleTimeString(),
        };
        arr.push(obj);
      });
      setExperiments(arr);
      setTotalPage(res.res.data.data.totalPages);
      let divisor = parseInt(res.res.data.data.totalPages / limits);
      let remainder = res.res.data.data.totalPages % limits == 0 ? 0 : 1;
      setNoOfPages(divisor + remainder);
      setCurrPage(pages);
    }
  };

  const increment = () => {
    setPage(page + 1);
  };
  const decrement = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const handleChangePage = (event, newPage) => {
    const _cookie = getCookie("recoil-persist");

    const user = JSON.parse(_cookie)["district_admin_v1"];
    setPaged(newPage);

    getListOfExperiments(event.selected, pageLimit, orderBy, order, user);
    history.replace({
      pathname: "/experiments",
      search:
        `?${serial ? `serial=${serial}&` : ""}` +
        "page=" +
        event.selected +
        "&limit=" +
        pageLimit +
        "&orderBy=" +
        orderBy +
        "&order=" +
        order,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPageLimit(parseInt(event.target.value, 10));
    setPaged(0);
    getListOfExperiments(0, parseInt(event.target.value, 10), orderBy, order);
    history.replace({
      pathname: "/experiments",
      search:
        `?${serial ? `serial=${serial}&` : ""}` +
        "page=0" +
        "&limit=" +
        parseInt(event.target.value, 10) +
        "&orderBy=" +
        orderBy +
        "&order=" +
        order,
    });
  };

  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("createdAt");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(pageLimit);
  const [classData, setClassData] = useState([]);
  const [studentData, setStudentData] = useState([]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const onSetOrder = (event, property) => {
    let orderTemp = order === "asc" ? "desc" : "asc";
    let urlPage = parseInt(params.get("page")) || 0;
    let urlLimit = parseInt(params.get("limit")) || pageLimit;
    let urlSerial = params.get("serial");
    if (parseInt(params.get("page")) || parseInt(params.get("limit"))) {
      history.replace({
        pathname: "/experiments",
        search:
          `?${urlSerial ? `serial=${urlSerial}&` : ""}` +
          "page=" +
          urlPage +
          "&limit=" +
          urlLimit +
          "&orderBy=" +
          property +
          "&order=" +
          orderTemp,
      });
      getListOfExperiments(urlPage, urlLimit, property, orderTemp, myUser);
      setPaged(urlPage);
      setSerial(urlSerial);
      setPageLimit(urlLimit);
      setOrder(orderTemp);
      setOrderBy(property);
    }
  };
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = experiments.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };
  const initiateEdit = (data) => {
    setCurrentEdit(data);

    setOpen(true);
    setEditmode(true);
    getSchoolByDistrict();
  };
  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };
  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;
  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - experiments.length) : 0;

  const getSchoolByDistrict = async () => {
    const _cookie = getCookie("recoil-persist");

    const user = JSON.parse(_cookie)["district_admin_v1"];
    const res = await getSchoolByDistrictAdmin(user.token);
    setSchoolData(res?.res?.data?.data?.schools);
    // res?.res?.data?.data?.schools?.map((item) => {
    // 	if (item._id === currentEdit?.school && typeof(currentEdit?.school)) {
    // 		setCurrentEdit({ ...currentEdit, school: item })
    // 		return
    // 	}

    // })
  };
  const getClassBySchoolId = async (id) => {
    const _cookie = getCookie("recoil-persist");

    const user = JSON.parse(_cookie)["district_admin_v1"];
    const res = await getAllSchoolTeachers(id, user.token);
    setTeacherData(res?.res?.data);
  };

  const getclassbyTeacherId = async (id) => {
    const _cookie = getCookie("recoil-persist");

    const user = JSON.parse(_cookie)["district_admin_v1"];
    const res = await getClassesByTeachers(id, user.token);
    //console.logres?.res?.data);
    setClassData(res?.res?.data);
  };

  const getStudentByclassIds = async (id) => {
    const _cookie = getCookie("recoil-persist");
    const user = JSON.parse(_cookie)["district_admin_v1"];
    const res = await getStudentByclassId(id, user.token);
    //console.logres?.res?.data);
    setStudentData(res?.res?.data);
  };

  useEffect(() => {
    if (currentEdit?.school && currentEdit?.school.length > 3) {
      getClassBySchoolId(currentEdit?.school);
    }
  }, [currentEdit?.school]);

  useEffect(() => {
    if (currentEdit?.teacher?.length > 0) {
      getclassbyTeacherId(currentEdit?.teacher[0]);
    }
  }, [currentEdit?.teacher]);

  useEffect(() => {
    if (currentEdit?.classId?.length > 0) {
      getStudentByclassIds(currentEdit?.classId);
    }
  }, [currentEdit?.classId]);

  return (
    <div style={{ height: "100%", overflow: "hidden" }}>
      <NavBar />
      <br />
      <div className="d-flex justify-content-end align-items-end">
        <ReactPaginate
          previousLabel="Previous"
          nextLabel="Next"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          pageCount={noOfPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handleChangePage}
          containerClassName="pagination"
          activeClassName="activePage active"
          forcePage={currPage}
        />
      </div>
      <Box sx={{ width: "100%", overflow: "none" }}>
        <Paper sx={{ width: "100%", mb: 2 }}>
          <EnhancedTableToolbar numSelected={selected.length} />
          <TableContainer 
            sx={{
              maxHeight: "calc(100vh - 250px)",
              overflow: "auto",
              width: "100%",
            }}>
            <Table
              aria-labelledby="tableTitle"
              sx={{ tableLayout: "fixed" }}
              // size={ 'small'}
              stickyHeader
            >
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={onSetOrder}
                rowCount={experiments.length}
              />
              <TableBody>
                {experiments.map((experiments, index) => {
                  const isItemSelected = isSelected(experiments.name);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <TableRow
                      hover
                      onClick={(event) => handleClick(event, experiments.name)}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={experiments.name}
                      selected={isItemSelected}
                    >
                      <TableCell align="center">
                        {experiments?.serialId}
                      </TableCell>
                      <TableCell align="center">{experiments._id}</TableCell>
                      <TableCell align="center">
                        {experiments?.deviceName}
                      </TableCell>
                      <TableCell align="center">
                        {Number.isInteger(experiments?.fuelVolume)
                          ? experiments?.fuelVolume
                          : experiments?.fuelVolume.toFixed(2)}{" "}
                        ml
                      </TableCell>
                      <TableCell align="center">
                        {Number.isInteger(experiments?.nozzleDia)
                          ? experiments?.nozzleDia
                          : experiments?.nozzleDia.toFixed(2)}{" "}
                        mm
                      </TableCell>
                      <TableCell align="center">
                        {Number.isInteger(experiments?.pressure)
                          ? experiments?.pressure
                          : experiments?.pressure.toFixed(2)}{" "}
                        psi
                      </TableCell>
                      <TableCell align="center">
                        {experiments.className}
                      </TableCell>
                      <TableCell align="center">
                        {experiments.studentName}
                      </TableCell>
                      <TableCell align="center">{experiments.date}</TableCell>
                      <TableCell align="center">{experiments.time}</TableCell>
                      <TableCell>
                        <Link
                          to={`/experiments/${experiments._id}`}
                          className="btn btn-sm btn-outline-primary"
                        >
                          Analyze
                        </Link>
                      </TableCell>
                      <TableCell>
                        <Tooltip title="Edit" placement="left">
                          <button
                            className="btn btn-sm btn-outline-primary mr-2"
                            onClick={() => initiateEdit(experiments)}
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 30 30"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13.75 5H5C4.33696 5 3.70107 5.26339 3.23223 5.73223C2.76339 6.20107 2.5 6.83696 2.5 7.5V25C2.5 25.663 2.76339 26.2989 3.23223 26.7678C3.70107 27.2366 4.33696 27.5 5 27.5H22.5C23.163 27.5 23.7989 27.2366 24.2678 26.7678C24.7366 26.2989 25 25.663 25 25V16.25"
                                stroke="#495057"
                                stroke-width="2.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M23.125 3.125C23.6223 2.62772 24.2967 2.34835 25 2.34835C25.7033 2.34835 26.3777 2.62772 26.875 3.125C27.3723 3.62228 27.6517 4.29674 27.6517 5C27.6517 5.70326 27.3723 6.37772 26.875 6.875L15 18.75L10 20L11.25 15L23.125 3.125Z"
                                stroke="#495057"
                                stroke-width="2.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </button>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  );
                })}
                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: (dense ? 33 : 53) * emptyRows,
                    }}
                  >
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        <Dialog handleClose={handleClose} open={open} fullWidth>
          <section id="hero-Msd">
            {editmode ? (
              <>
                <DialogTitle>
                  <Grid container justify="space-between" alignItems="center">
                    <Typography variant="h6" style={{ fontWeight: "600" }}>
                      Edit Experiment
                    </Typography>
                    <IconButton onClick={handleClose}>
                      <CloseIcon
                        style={{ border: "2px solid black", fontSize: "30px" }}
                      />
                    </IconButton>
                  </Grid>
                </DialogTitle>
                <form onSubmit={(e) => handleEditSubmit(e)} className="form">
                  <div className="col-md-9 text-left  col-9 m-auto">
                    <div className="form-group mt-4   p-20">
                      <div className="form-group">
                        <label>School</label>
                        <AutoCompletes
                          value={currentEdit?.school}
                          label={"School"}
                          options={schoolData}
                          setValue={(value) =>
                            setCurrentEdit({
                              ...currentEdit,
                              school: value?._id,
                              teacher: [],
                              className: "",
                              studentName: "",
                            })
                          }
                        />
                      </div>
                      <div className="form-group">
                        <label>Teacher</label>
                        <AutoCompletes
                          value={currentEdit?.teacher[0]}
                          label={"Teacher"}
                          options={teacherData}
                          setValue={(value) =>
                            setCurrentEdit({
                              ...currentEdit,
                              teacher: [value?._id],
                              className: "",
                              studentName: "",
                            })
                          }
                        />
                      </div>

                      <div className="form-group">
                        <label>Class</label>
                        <AutoCompletes
                          value={currentEdit?.className}
                          label={"Class"}
                          options={classData}
                          setValue={(value) =>
                            setCurrentEdit({
                              ...currentEdit,
                              className: value?.name,
                              classId: value?._id,
                              studentName: "",
                            })
                          }
                        />
                      </div>

                      <div className="form-group">
                        <label>Student</label>
                        <AutoCompletes
                          value={currentEdit?.studentName}
                          label={"Student"}
                          options={studentData}
                          setValue={(value) =>
                            setCurrentEdit({
                              ...currentEdit,
                              studentName: value?.loginId,
                            })
                          }
                        />
                      </div>
                      <div className="form-group">
                        <label>Bottle Volume (ml)</label>
                        <input
                          type="text"
                          className="form-control"
                          required
                          value={currentEdit.bottleVolume}
                          onChange={(e) => {
                            setCurrentEdit({
                              ...currentEdit,
                              bottleVolume: e.target.value,
                            });
                          }}
                        />
                      </div>
                      <div className="form-group">
                        <label>Fuel Volume (ml)</label>
                        <input
                          type="text"
                          className="form-control"
                          required
                          Value={currentEdit.fuelVolume}
                          onChange={(e) => {
                            setCurrentEdit({
                              ...currentEdit,
                              fuelVolume: e.target.value,
                            });
                          }}
                        />
                      </div>
                      <div className="form-group">
                        <label>Nozzle Diamenter (mm)</label>
                        <input
                          type="text"
                          className="form-control"
                          required
                          value={currentEdit.nozzleDia}
                          onChange={(e) => {
                            setCurrentEdit({
                              ...currentEdit,
                              nozzleDia: e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                    {!clicked && (
                      <input
                        type="submit"
                        className="custom-form-button"
                        value="Update"
                      />
                    )}
                    {clicked && (
                      <input
                        type="submit"
                        className="custom-form-button"
                        value="Updating"
                        disabled
                      />
                    )}
                    <br />
                  </div>
                </form>
                <br />
              </>
            ) : null}
          </section>
        </Dialog>

        <Snackbar
          open={snackBarShow}
          autoHideDuration={3000}
          onClose={SnackClose}
        >
          <Alert
            onClose={SnackClose}
            severity={snackBarSeverity}
            sx={{ width: "100%" }}
          >
            {snackBarMessage}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
}
